import {connect} from 'react-redux'

import {QuickCollabs} from './quickcollabs.component'

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
    }}

const QuickCollabsContainer = connect(
)(QuickCollabs)

export default QuickCollabsContainer
